import { TRENDING_HASHTAGS } from "../configs/routes.js";
import api from "./api.js";

export const getHashTags = () =>
  new Promise((resolve, reject) => {
    api
      .post(TRENDING_HASHTAGS, {})
      .then((response) => resolve(response.data))
      .catch((err) => reject(err.message));
  });
